import * as React from 'react';
import { SVGProps } from 'react';

const SvgCheckmarkOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="m9 16.586-4.293-4.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l11-11a1 1 0 0 0-1.414-1.414L9 16.586Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCheckmarkOutlined;
